import type { ApiMachineryWithBaseInfoById } from '~/types'
import type { MachineryUVVReport } from '~/server/pdf-generation/getMachineryUVVReport'
/**
 * Columns used in MachineryUVVReport related components
 * Useful to display the same column data card on the app-side and on the server-side PDF generation
 *
 * `translate` is the translation function provided by `@nuxt/i18n`. We pass it in directly as the parent i18n-instances have slightly different types between app- and server-side.
 */
export default (translate: I18n['t']) => {
  const machineryColumn: OneDataColumn<ApiMachineryWithBaseInfoById | MachineryUVVReport['machinery']>[] = [
    {
      title: translate('machinery.id.label'),
      key: 'id',
    },
    {
      title: translate('machinery.field.producerCompanyName.name'),
      key: 'producerCompanyName',
    },
    {
      title: translate('common.field.type.name'),
      key: 'type',
      render: (row) => {
        return row.type.name
      },
    },
    {
      title: translate('machinery.field.serialNumber.name'),
      key: 'receptionMachinery',
      render: (row) => {
        return row.receptionMachinery?.serialNumber
      },
    },
    {
      title: translate('machinery.field.yearBuilt.name'),
      key: 'receptionMachinery',
      render: (row) => {
        return row.receptionMachinery?.yearBuilt
      },
    },
  ]

  return {
    machineryColumn,
  }
}
